<template>
<m-pageframe
    title="Search RedChirp Stripe Payment Methods"
>
<v-container
    fluid
    style="padding: 15px"
>

   <v-text-field
    autocomplete="off"
    label="Search"
    prepend-icon="mdi-magnify"
    v-model="full_text"
    v-on:input="update"
   >
    <v-menu
        bottom
        offset-y
        slot="append-outer"
    >
        <template v-slot:activator="{ on }">
            <v-icon
                v-on="on"
            >
                mdi-dots-vertical
            </v-icon>
        </template>
   
        <v-list>
            <v-list-item
                v-on:click="onClickSyncWithStripe()"
            >
                <v-list-item-title>Sync with stripe...</v-list-item-title>
            </v-list-item>


            <v-divider/>
            
            <v-list-item
                v-on:click="onClickExport()"
            >
                <v-list-item-title>Export to excel...</v-list-item-title>
            </v-list-item>

            <v-divider/>

            <v-list-item
                v-on:click="doUpdate()"
            >
                <v-list-item-title>Refresh...</v-list-item-title>
            </v-list-item>

        </v-list>
    </v-menu> 
   </v-text-field>

   <v-layout row wrap>
        <v-flex flex-grow-0>
            <m-boolean-search-filter
                style="margin-top: 5px; margin-left: 10px;"
                label="Linked to Organization"
                v-model="filter_linked_to_organizations"
                v-on:input='doUpdate'
            />
        </v-flex>
    </v-layout>

   <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        class="elevation-1"

        :options.sync="table_options"
        :items-per-page="50"

        :footer-props="{
            showFirstLastPage: true,
            itemsPerPage: 50,
            disableItemsPerPage: true,
            itemsPerPageOptions: [50, 100],
        }"

        :server-items-length="result_count"
   >

    <template 
        v-slot:item.customer_description="{ item }"
    >
        <span
            v-html="prettyCustomerDescription(item)"
        />
        
    </template>

    <template v-slot:item.time_created="{ item }">
        {{$rc.pretty(item.time_created,'date')}}
    </template>
   
    <template v-slot:item.time_created="{ item }">
        {{$rc.pretty(item.time_created,'date')}}
    </template>

    <template v-slot:item.issuer="{ item }">
        {{item.card_brand != null ? item.card_brand : item.us_bank_account_bank_name}}
    </template>

     <template v-slot:item.ending="{ item }">
        {{item.card_ending != null ? 'x'+item.card_ending : 'x'+item.us_bank_account_ending}}
    </template>

    <template v-slot:item.expires="{ item }">
        {{prettyExpires(item)}}
    </template>

    <template v-slot:item.is_active_payment_method="{ item }">
         <v-simple-checkbox
                :value="item.is_active_payment_method"
                :ripple="false"
                readonly
            />
    </template>

    <template v-slot:item.action="{ item }">
        <v-menu 
            bottom 
            offset-y  
        >
        
        <template v-slot:activator="{ on }">
                
            <v-icon 
                v-on="on"
            >
                mdi-dots-vertical
            </v-icon>
                
        </template>
        
        <v-list>
            <v-list-item
                v-on:click="onClickMakeActivePaymentMethod(item)"
                :disabled="item.linked_to_organization_id == null"
            >
                <v-list-item-title>Make active payment method</v-list-item-title>
            </v-list-item>

            <v-list-item
                v-on:click="onClickUnlink(item)"
                v-if="item.linked_to_organization_id != null"
            >
                <v-list-item-title>Unlink from {{item.linked_to_organization_label}}...</v-list-item-title>
            </v-list-item>

            <v-list-item
                v-on:click="onClickLink(item)"
                v-if="item.linked_to_organization_id == null"
            >
                <v-list-item-title>Link to organization...</v-list-item-title>
            </v-list-item>

            <v-list-item
                v-on:click="onClickLinkAndMakeActive(item)"
                v-if="item.linked_to_organization_id == null"
            >
                <v-list-item-title>Link to organization and make active payment method...</v-list-item-title>
            </v-list-item>

            <v-divider/>

            <v-list-item
                v-on:click="onClickViewInStripe(item)"
                :disabled="item.customer_url_view_in_payment_gateway == null"
            >
                <v-list-item-title>View in Stripe...</v-list-item-title>
            </v-list-item>

            <v-divider/>

             <v-list-item
                v-on:click="onClickLink(item)"
                v-if="item.linked_to_organization_id != null"
            >
                <v-list-item-title>Link to additional organization...</v-list-item-title>
            </v-list-item>
        
        </v-list>
        
        </v-menu> 
    </template>
   
   </v-data-table>

   <m-autocomplete-organization
        :value="null"
        dialog_only
        ref="search-orgs"
        v-on:input="doLink"
    />


</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {
    data() {
        return {
            full_text: null,

            results: [],
            
            headers: [
                { text: 'Customer Id', value: 'customer_id'},
                { text: 'Customer', value: 'customer_full_name'},
                { text: 'Customer Desc', value: 'customer_description'},
                { text: 'Method Id', value: 'payment_method_id'},
                { text: 'Created', value: 'time_created'},
                { text: 'Type', value: 'payment_method_type'},
                { text: 'Issuer', value: 'issuer', sortable: false},
                { text: 'Ending', value: 'ending', sortable: false},
                { text: 'Expires', value: 'expires', sortable: false},
                { text: 'Linked To', value: 'linked_to_organization_label'},
                { text: 'Active', value: 'is_active_payment_method'},
                { text: 'Action', value: 'action', sortable: false},
            ],

            last_link_item: null,

            filter_linked_to_organizations: null,

            table_options: null,
            result_count: 0,
        }
    },

   

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            let linked_to_organization_id = null;

            if ( this.filter_linked_to_organizations == true )
            {
                linked_to_organization_id = { type: 'is-not-blank' }
            }

            if ( this.filter_linked_to_organizations == false )
            {
                linked_to_organization_id = { type: 'is-blank' }
            }

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/admin/red-chirp-payments',
            
                'params' : {
                        ...this.$rc.parseVTableOptions(this.table_options, 'customer_full_name|payment_method_id|payment_gateway_id'),
                        'full_text': this.full_text,
                        'linked_to_organization_id': linked_to_organization_id,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                        this.result_count = data.result_count;
                    },
            
                'on_error': 'Unable to search stripe customers / payment methods',
            });
        },

        prettyExpires(item)
        {
            if ( item.card_exp_month == null || item.card_exp_year == null )
                return null;

            return item.card_exp_month + '/' + item.card_exp_year;
        },

        onClickMakeActivePaymentMethod(item)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/admin/red-chirp-payments/set-active-payment-method',
            
                'params' : {
                        'organization_id': item.linked_to_organization_id,
                        'payment_method_id': item.payment_method_id,
                    },
            
                'on_success': (data) => {
                        this.doUpdate();
                    },
            
                'on_error': 'Unable to make default payment method.',
            });
        },

        onClickUnlink(item)
        {
            this.$rc.confirm({
                'title': 'Confirm Unlink',
                'body': 'Are you sure that you want to unlink this customer from '+item.linked_to_organization_label+"?",
                'btn_text_ok': 'Unlink',
                'btn_text_cancel': 'No',
                'on_ok': () => {
                    this.doUnlink(item);
                },
            });
        },

        doUnlink(item)
        {
             this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/admin/red-chirp-payments/unlink',
            
                'params' : {
                        'customer_id': item.customer_id
                    },
            
                'on_success': (data) => {
                        this.doUpdate();
                    },
            
                'on_error': 'Unable to unlink customer',
            });
        },

        onClickLink(item)
        {
            this.last_link_item = _.cloneDeep(item);
            this.last_link_item.make_active = false;

            this.$refs['search-orgs'].showDialog();
        },

        onClickLinkAndMakeActive(item)
        {
            this.last_link_item = _.cloneDeep(item);
            this.last_link_item.make_active = true;
            
            this.$refs['search-orgs'].showDialog();
        },

        doLink(organization_id)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/admin/red-chirp-payments/link',
            
                'params' : {
                        'customer_id': this.last_link_item.customer_id,
                        'organization_id': organization_id,
                    },
            
                'on_success': (data) => {
                        if ( this.last_link_item.make_active )
                        {
                            this.$rc.rest({
                                'spinner': false,
                                'endpoint': 'PUT: /api/v1/admin/red-chirp-payments/set-active-payment-method',
                            
                                'params' : {
                                        'organization_id': organization_id,
                                        'payment_method_id': this.last_link_item.payment_method_id,
                                    },
                            
                                'on_success': (data) => {
                                        this.doUpdate();
                                    },
                            
                                'on_error': 'Unable to make default payment method.',
                            });
                        }
                        else
                        {
                            this.doUpdate();
                        }
                    },
            
                'on_error': 'Unable to link customer to organization',
            });
        },
        

        onClickExport() {
            
            this.$rc.excelExport(
                    'EXPORT: /api/v1/admin/red-chirp-payments/excel-export',
                    {
                    }
                );

        },

        onClickViewInStripe(item)
        {
            window.open(item.customer_url_view_in_payment_gateway, '_blank');
        },

        onClickSyncWithStripe()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/admin/tasks/run',
            
                'params' : {
                        'id': 'stripe_sync',
                    },
            
                'on_success': (data) => {
                        this.$rc.alert('Stripe sync started', 'A full sync with Stripe has been started.  This can take a few minutes to complete.');
                    },
            
                'on_error': 'Unable to populate sync with stripe',
            }); 
        },

        prettyCustomerDescription(item)
        {
            if ( item.pending_ach_verification )
            {
                return item.customer_description+"<br/><b>Pending ACH Verification</b>";
            }

            return item.customer_description;
        },
    },

    watch: {
        table_options(newValue, oldValue) {
            this.doUpdate();
        }
    },
}
</script>

<style lang="scss" scoped>
</style>